import { PredefinedTraits } from "../../../ProductDetails/components/ProductTrait";
import {
  AliasesParameter,
  CountryOfOriginDescriptorParam,
  LinearConfigParameter,
  OldDesignationParameter,
  SchaefflerIdParameter,
  TariffParameter,
} from "../../../common/components/Product/ProductParams";
import { NewVersionMessage } from "../../../common/components/Messages/NewVersionMessage";
import { isKITProduct } from "../../../models/ProductData";
import { HousingMessages } from "../../../common/components/Messages/HousingMessages";
import { useTranslation } from "react-i18next";

import { ProductDescriptorContext } from "~/feature/Product/ProductContext";
import { Product } from "~/feature/Product";
import { getIsContractAvailable } from "~/ProductDetails/redux/productDetailsSelectors";
import { FCCTag } from "~/FreeCapacityPush/components/FCCTag/FCCTag";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import ProductMMD from "~/feature/Product/elements/ProductMMD";
import { Stack } from "@mui/material";

interface Props {
  productDescriptor: ProductDescriptor;
  isFcc: boolean;
}

export const CART_PRODUCT_IMAGE_WIDTHS = {
  product: "115px",
  gap: "20px",
  brand: "30px",
  manufacturer: "22px",
};
const CartEntryProductInfo = ({ productDescriptor, isFcc }: Props) => {
  const { t } = useTranslation();

  const data = productDescriptor.base;
  const isContractProduct = getIsContractAvailable(productDescriptor);

  const isKIT = isKITProduct(data);

  return (
    <ProductDescriptorContext value={productDescriptor}>
      <Stack gap={1} sx={{ alignItems: "flex-start" }}>
        <Product.PrimaryImageWithLogos size={"small"} />
        {isKIT && <HousingMessages.NotFinal className={"mt-2"} />}

        <Product.FullDesignation className={"title-medium f-bold"} />
        {data.marketDesignation && <ProductMMD marketDesignation={data.marketDesignation} />}
        <Product.ShortDescription clickable={false} />

        {isFcc && <FCCTag />}

        <NewVersionMessage className={"mt-2"} baseProduct={data} />
        <Stack gap={1} sx={{ mt: 1 }}>
          <LinearConfigParameter label={t("cartPage.systemLayout.label")} />
          <OldDesignationParameter data-test-id={"old-designation"} label={t("productDetailPage.oldDesignation")} />
          <SchaefflerIdParameter data-test-id={"schaeffler-id"} />
          <AliasesParameter mode={"13-digits"} />
          <TariffParameter />
          {/* <CountryOfOriginParam product={productDescriptor.base} /> */}
          <CountryOfOriginDescriptorParam />
        </Stack>

        {isContractProduct && <PredefinedTraits.ContractProduct />}
      </Stack>
    </ProductDescriptorContext>
  );
};
export default CartEntryProductInfo;
